<div class="flex flex-col gap-4 p-4">
  <h1 class="!m-0">Custom Reports</h1>

  <pr-custom-reports-list [customReports]="filteredReports()">
    <button
      *prHasPermission="[createCustomReportsPermission]"
      mat-flat-button
      color="primary"
      (click)="createCustomReport()"
    >
      Create Custom Report
    </button>
  </pr-custom-reports-list>
</div>
